import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 2C8.96243 2 6.5 4.46243 6.5 7.5C6.5 10.5376 8.96243 13 12 13C15.0376 13 17.5 10.5376 17.5 7.5C17.5 4.46243 15.0376 2 12 2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 14C5.23858 14 3 16.2386 3 19V22H21V19C21 16.2386 18.7614 14 16 14H14.618L12 19.2361L9.38197 14H8Z"}}]};

const UserBusinessFilled = Vue.extend<IconProps>({
  name: 'UserBusinessFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'user-business-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default UserBusinessFilled;
